import useParticipantsWithHost from '../../hooks/useParticipantsWithHost';
import ModeratorBox from '../ModeratorBox/ModeratorBox';
import CircularTimer from './CircularTimer';
import ParticipantCamera from './ParticipantCamera';
import './SlidesCommon.css';

export default function ContentWaitingPartner() {
  const { participantA, participantB, participantMod } = useParticipantsWithHost();

  return (
    <div className="slide-container" style={{ position: 'relative' }}>
      <ModeratorBox />
      <div className="centered-container">
        <div className="column-container">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24, marginTop: 32 }}>
            <ParticipantCamera participant={participantA} />
            <ParticipantCamera participant={participantB} />
            {participantMod && <ParticipantCamera participant={participantMod} />}
          </div>
        </div>
        <div className="column-container">
          <span className="white-title">You&apos;re the first to arrive...</span>
          <div className="white-subtitle">
            <p>Your partner confirmed recently.</p>
            <p>Please wait a little!</p>
          </div>

          {/* Timer circular */}
          <CircularTimer duration={300} />
        </div>
      </div>
    </div>
  );
}
